"use client";

import { useEffect, useState } from "react";
import { Eye } from "lucide-react";
import { useTranslations } from "next-intl";

export function ViewerCount() {
  const t = useTranslations("product");
  // Computed only after mount: `new Date().getHours()` differs between the
  // UTC server render and the visitor's local clock, which caused React
  // #425/#422 hydration mismatches on /wigs for every non-UTC visitor.
  const [viewerCount, setViewerCount] = useState<number | null>(null);
  useEffect(() => {
    setViewerCount(5 + (new Date().getHours() % 16));
  }, []);

  if (viewerCount === null) return null;

  return (
    <div className="flex items-center gap-1.5 text-xs text-brand-muted">
      <Eye className="w-3.5 h-3.5" /> {t("peopleViewingNow", { count: viewerCount })}
    </div>
  );
}
